import React from 'react';

const LoadingSpinner = () => {
  return (
    <div style={styles.loadingContainer}>
      <div style={styles.loadingSpinner}>
        <div style={{...styles.spinnerRing, ...styles.ring1}}></div>
        <div style={{...styles.spinnerRing, ...styles.ring2}}></div>
        <div style={{...styles.spinnerRing, ...styles.ring3}}></div>
        <div style={styles.centerText}>Ziegler</div>
      </div>
     
    </div>
  );
};

const styles = {
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    padding: '2rem',
    textAlign: 'center',
    opacity: 0,
    animation: 'fadeIn 0.4s ease-out forwards'
  },
  loadingSpinner: {
    position: 'relative',
    width: '120px',
    height: '120px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  spinnerRing: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: '4px solid transparent',
    borderTop: '4px solid #099CD6',
    borderRadius: '50%',
    animation: 'spin 1.2s linear infinite'
  },
  ring2: {
    width: '80%',
    height: '80%',
    top: '10%',
    left: '10%',
    borderTop: '4px solid #66b3e0',
    animationDelay: '-0.4s'
  },
  ring3: {
    width: '60%',
    height: '60%',
    top: '20%',
    left: '20%',
    borderTop: '4px solid #99cceb',
    animationDelay: '-0.8s'
  },
  centerText: {
    position: 'relative',
    zIndex: 10,
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#099CD6',
   
   
  },
  loadingText: {
    opacity: 0,
    animation: 'fadeIn 0.6s ease-out 0.3s forwards',
    marginTop: '20px',
    fontSize: '18px',
    color: '#666'
  }
};

export default LoadingSpinner;